import React from "react";
import moment from "moment";
import { useTranslation } from "react-i18next"; 
import SuccessBookImage from "../../../../assets/images/icons/blueSuccess.svg";
import ErrorBookImage from "../../../../assets/images/icons/failed-book.svg";
import { useNavigate } from "react-router-dom";
import { GeneralButton, Modal } from "../../../../components";

interface IAppointmentMessage {
  isOpen: boolean;
  onClose: () => void;
  data?: any;
  status?: "success" | "error";
  message?: string;
}

const AppointmentMessage: React.FC<IAppointmentMessage> = ({
  isOpen,
  onClose,
  status,
  data,
  message,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="flex flex-col items-center gap-6 text-center">
        <img
          alt={status}
          className="m-auto w-24 max-w-32"
          src={status == "success" ? SuccessBookImage : ErrorBookImage}
        />
        <div className="flex flex-col w-3/4 gap-4">
          <span className="text-lg font-bold">
            {status == "success"
              ? t("appointment_booked_successfully")
              : t("appointment_booking_failed")}
          </span>
          {status == "success" ? (
            <span className="text-sm text-body-text">
              {t("you_make_booking_for")}
              <span className="font-semibold text-primary-text">
                {` ${t(data?.Account?.FullName)} ${t("at")} ${moment(data?.appointmentDate).format("dddd DD, MMMM hh:mm a")}.`}
              </span>
            </span>
          ) : (
            <span>{t(message ?? "")}</span>
          )}
        </div>
        <GeneralButton
          title={t("ok_go_to_home")}
          className="mx-auto w-fit !px-4"
          onClick={()=>{
            onClose();
            navigate("/");
          }}
        />
      </div>
    </Modal>
  );
};

export default AppointmentMessage;
